import { styled } from 'linaria/react';

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--space-200);

  @media (--only-tablet) {
    margin-bottom: var(--space-200);
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-100);
`;

export const LayerContainer = styled.div`
  @media (--only-tablet) {
    margin-top: var(--space-200);
    margin-bottom: var(--space-100);
    & > div {
      width: 100%;
    }
  }
`;
